<div class="step-progress" [class.code-crosswalk-tab]="currentTab === tabName.CODECROSSWALK_TAB">
  <div class="container-1" #stepContainer>
    <ng-container *ngFor="let item of itemProgressList; index as i">
      <div
        class="check-box"
        [ngClass]="{
          complete: item.status === status.COMPLETED,
          active: item.status === status.IN_PROGRESS
        }"
      >
        <app-svg *ngIf="item.names[i] === importDocumentStep.Summary && hasFailed"
          iconType="stepFail"></app-svg>

      <app-svg *ngIf="!(item.names[i] === importDocumentStep.Summary && hasFailed)"
        iconType="stepCheckbox"></app-svg>
        <div
            class="progress-line"
          [ngClass]="{
            complete: item.status === status.COMPLETED,
            active: item.status === status.IN_PROGRESS
          }"
          *ngIf="i !== totalSteps - 1"
        >
          <div class="progress-percent"></div>
        </div>
        <div class="info text-box">
          <span
            class="step"
            [ngClass]="{
              errors: item.names[i] === importDocumentStep.Errors,
              map: item.names[i] === importDocumentStep.Map,
              template:
                item.names[i] === importDocumentStep.Preview ||
                item.names[i] === importDocumentStep.Import
            }"
            >{{ item.names[i] }}</span
          >
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="step-content">
  <ng-content select="app-progress-step"></ng-content>
</div>